import Vue from "vue"
import SockJS from "sockjs-client"
import { Client } from "@stomp/stompjs"

// 创建stomp客户端
export default function(options) {
    const eventBus = new Vue()
    const {
        url,
        connectHeaders = {},
        reconnectDelay = 5000,
        heartbeatIncoming = 0,
        heartbeatOutgoing = 0,
    } = options

    const client = new Client({
        brokerURL: url,
        connectHeaders,
        debug: function(str) {
            console.log(str)
        },
        reconnectDelay,
        heartbeatIncoming,
        heartbeatOutgoing,
    })

    // Fallback code
    if (typeof WebSocket !== 'function' || !url.startsWith('ws:') || !url.startsWith('wss:')) {
        client.webSocketFactory = function() {
            return new SockJS(url)
        }
    }

    client.onConnect = function(frame) {
        return eventBus.$emit("connect", frame)
    }

    client.onStompError = function(frame) {
        return eventBus.$emit("error", frame)
    }

    client.onWebSocketClose = function(e) {
        return eventBus.$emit("close", e)
    }

    // event
    client.$on = function(eventName, handler) {
        eventBus.$on(eventName, function(...args) {
            handler.call(client, ...args)
        })

        return client
    }
    client.$emit = eventBus.$emit

    // fallback v2.3.3
    client.send = function(channel, headers, body) {
        return client.publish({
            destination: channel,
            headers: headers,
            body,
        })
    }
    client.disconnect = function() {
        return client.deactivate()
    }

    client.activate()

    return client
}